import type { ReactNode } from 'react';

export function Panel({ eyebrow, title, right, children }: {
  eyebrow?: string; title: string; right?: ReactNode; children: ReactNode;
}) {
  return (
    <section className="panel">
      {/* The design file's Card header: the title with its subtitle stacked under it
          and a rule beneath the pair. .htitle is what opts a header into that. */}
      <header>
        <div className="htitle">
          <h2 className="t-heading-h3">{title}</h2>
          {eyebrow && <span className="eyebrow t-caption">{eyebrow}</span>}
        </div>
        {right}
      </header>
      {children}
    </section>
  );
}

/** Nobody in a list is not a zero. It is a sentence. */
export function NoneRow({ children }: { children: ReactNode }) {
  return <div className="none t-body-medium">{children}</div>;
}

/** A number the Owner seat is allowed to show, and the way back to the names. */
export function Stat({ value, label, onOpen }: { value: number | string; label: string; onOpen?: () => void }) {
  return (
    <div className="stat">
      <div className="v t-display-xsmall">{value}</div>
      <div className="l t-caption">{label}</div>
      {onOpen && (
        <button type="button" className="linkish t-label-small" onClick={onOpen}>
          Show the names
        </button>
      )}
    </div>
  );
}
